<template>

    <v-card class="pa-4" elevation="10" shaped outlined>
      <h3 class="text-right my-4">رهگیری پرداخت الکترونیکی</h3>
      <v-form  @submit.prevent="sendInfo">
        <v-row>
        <v-col cols="12" xs="12" sm="6" md="6" lg="6">
          <v-text-field
            dense
            v-model="NC"
            label="کدملی یا شماره پیگیری تراکنش"

          ></v-text-field>
        </v-col>
        <v-col  cols="12" xs="12" sm="6" md="6" lg="6">
          <v-btn   class="primary float-sm-right" @click="sendInfo"
            >تایید</v-btn
          >
        </v-col>
      </v-row>
      </v-form>
      <v-row class="d-flex justify-center">
      <div class="text-center paginate_section" v-if="tracks && tracks.length !== 0 ">
        <template v-if="pagination.count > pagination.take" class="ma-4">
          <v-pagination
            :length="Math.ceil(pagination.count / take)"
            v-model="pageNumber"
            :next="next"
            :previous="previous"
            :total-visible="7"
          ></v-pagination>
        </template>
      </div>

            <v-chip v-if="pagination.count!=0" class="mt-6 mb-4 mb-md-0 grey lighten-2  float-sm-right" label pill
            >تعداد: {{ pagination.count }} رکورد</v-chip
            >

      </v-row>
      <v-simple-table class="table" fixed-header height="100%"  v-if="tracks && tracks.length !== 0 ">
        <template

          v-slot:default
        >
          <thead >
            <tr >
              <th class="text-center T-head">درگاه</th>
<!--              <th class="text-center T-head">TerminalID</th>-->
              <th class="text-center T-head">بابت</th>
              <th class="text-center T-head">OrderID</th>
              <th class="text-center T-head">مبلغ (ریال)</th>
              <th class="text-center T-head">تاریخ ایجاد</th>
              <th class="text-center T-head">رفرنس</th>
<!--              <th class="text-center T-head">وضعیت</th>-->
              <th class="text-center T-head">نتیجه</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(track, index) in tracks" :key="index">
              <td >{{ track.GW.Name }}</td>
<!--              <td>{{ track.TerminalID }}</td>-->
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    >{{ track.Group }}
                    </span>
                  </template>
                  <span>TerminalID:{{ track.TerminalID }}</span>
                </v-tooltip>
                </td>
              <td>{{ track.orderId }}</td>
              <td>{{ Number(track.amount).toLocaleString() }}</td>
              <td>{{ track.CreateOn }}</td>
              <td>{{ track.Reference }}</td>
<!--              <td>{{ track.Status }}</td>-->
              <td>
                <v-tooltip bottom>
                <template
                  v-if="
                    track.Status &&
                    track.Status.charAt(0) === '0' &&
                    track.Status.charAt(1) === ':'
                  "
                  v-slot:activator="{ on, attrs }"
                >
                  <v-icon
                      color="green"
                      small
                      v-bind="attrs"
                      v-on="on">
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
                <template
                    v-else
                    v-slot:activator="{ on, attrs }"

                >
                  <v-icon
                      color="red"
                      small
                      v-bind="attrs"
                      v-on="on">
                    mdi-cancel
                  </v-icon>
                </template>
                  <span>وضعیت: {{ track.Status }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

<!--      <div class="text-center" v-if="tracks && tracks.length !== 0 && showFlag">-->
<!--        <template v-if="pagination.count > pagination.take" class="ma-4">-->
<!--          <v-pagination-->
<!--            :length="Math.ceil(pagination.count / take)"-->
<!--            v-model="pageNumber"-->
<!--            :next="next"-->
<!--            :previous="previous"-->
<!--            :total-visible="7"-->
<!--          ></v-pagination>-->
<!--        </template>-->
<!--      </div>-->
      <!--      loading overlay-->
      <v-overlay :value="loadReportIsLoading">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <!--      loading overlay-->
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Track",
  data: () => ({
    page: 1,
    pageNumber: 1,
    take: 10,
    NC: "",
    flag: true,
    showFlag: false,
  }),
  computed: mapState({
    tracks: (state) => state.tracks,
    pagination: (state) => state.trackPagination,
    loadReportIsLoading: (state) => state.loadReportIsLoading==="User_Payment_Track", //TODO::Look ME!!!
    load_status:(state)=> state.loadReportIsLoading,
  }),
  created: function() {
    this.pagination.count = 0;
  },
  methods: {
    previous: () => this.pageNumber--,
    next: () => this.pageNumber++,
    sendInfo: function () {
      // Reset tracks!
      this.pageNumber=1;
      this.$store.commit("updateTracks", []);
      this.flag = true;
      this.showFlag = true;
      this.$store.commit("pushQueue", {
        functionName: "User_Payment_Track",
        data: {
          Page: this.pagination.page,
          Take: this.pagination.take,
          NC: this.NC,
        },
      });
    },
    changeFlag() {
      window.console.log(`changeFlag is called.`);
      this.flag = false;
      this.showFlag = false;
      this.pagination.count = 0;
    },
  },
  watch: {
    pageNumber() {
      window.console.log(`In watch Section, pageNumber is:`);
      window.console.log(this.pageNumber);
      // this.$store.commit('setLoadReportIsLoading',{newStatus : "track_page_has_loading"}); //TODO:: Look at ME!
      this.$store.commit("pushQueue", {
        functionName: "User_Payment_Track",
        data: {
          Page: this.pageNumber,
          Take: this.pagination.take,
          NC: this.NC,
        },
      });
    },
  },
};
</script>

<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(200, 200, 200, 0.1);
}
tbody td {
  font-size: 80% !important;
}
.paginate_section{
  margin: 20px 0;
}
.table {

  border: 1px solid #ededed;
}
.T-head{
  color: black!important;
  font-size:small !important;
}
.table td{
  direction: ltr!important;
}
</style>